import { append, prepend } from 'alkali'
import 'tools/super-accessor'

// make append and make always available on elements
HTMLElement.prototype.append = append
HTMLElement.prototype.prepend = prepend
export function forceRun() {}